module.exports = __webpack_public_path__ + "img/about4.ce505f75.png";